import Body from "./components/Body";
import Footer from "./components/Footer";
import Header from "./components/Header";

const App = () => (
    <div className="flex flex-col min-h-screen">
        <div className="container mx-auto px-12 flex-grow">
            <Header />
            <Body />
        </div>
        <Footer />
    </div>
)

export default App;